<template>
  <div class="container-fluid im-fluid" @click="$root.hideMenu">
    <h2 class="im-title">{{ $t("services.title") }}</h2>

    <div class="row">
      <div class="col-12 col-sm-12 col-lg-6 col-xl-4 border-right">
        <div class="im-col im-col-1">
          <div class="im-block">
            <h5 class="mb-4">{{ $t("services.business_analysis") }}</h5>

            <p>
              {{ $t("services.ba_intro") }}
            </p>

            <ul>
              <li class="mb-4">
                {{ $t("services.ba_question_1") }}
              </li>

              <li class="mb-4">
                {{ $t("services.ba_question_2") }}
              </li>

              <li class="mb-4">
                {{ $t("services.ba_question_3") }}
              </li>
              <li class="mb-4">
                {{ $t("services.ba_question_4") }}
              </li>
            </ul>

            <p>
              {{ $t("services.ba_conclusion") }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-lg-6 col-xl-4 border-right">
        <div class="im-col im-col-2">
          <div class="im-block">
            <h5 class="mb-4">{{ $t("services.project_management") }}</h5>

            <p>
              {{ $t("services.pm_philosophy") }}
            </p>

            <ol>
              <li class="mb-4">
                <p>
                  {{ $t("services.pm_principle_1_title") }}
                </p>

                <p>
                  {{ $t("services.pm_principle_1_text") }}
                </p>
              </li>

              <li class="mb-4">
                <p>
                  {{ $t("services.pm_principle_2_title") }}
                </p>

                <p>
                  {{ $t("services.pm_principle_2_text") }}
                </p>
              </li>

              <li class="mb-4">
                <p>
                  {{ $t("services.pm_principle_3_title") }}
                </p>

                <p>
                  {{ $t("services.pm_principle_3_text") }}
                </p>

                <ul>
                  <li class="mb-4">
                    {{ $t("services.pm_principle_3_question_1") }}
                  </li>

                  <li class="mb-4">
                    {{ $t("services.pm_principle_3_question_2") }}
                  </li>

                  <li>
                    {{ $t("services.pm_principle_3_question_3") }}
                  </li>
                </ul>
              </li>
            </ol>

            <p>
              {{ $t("services.pm_conclusion") }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-sm-12 col-xl-4">
        <div class="im-col im-col-3">
          <div class="im-block">
            <h5 class="mb-4">{{ $t("services.development") }}</h5>

            <p>
              {{ $t("services.dev_intro") }}
            </p>

            <p>
              {{ $t("services.dev_agile") }}
            </p>

            <p>
              {{ $t("services.dev_cloud") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ServicesSection",
  };
</script>
